module.exports = __webpack_public_path__ + "img/add-green.8071e8d5.svg";